export enum TrafficType {
  COMPANY = "company",
  EVENT = "event",
  USER = "user",
}
